import React, { Component, PropTypes } from 'react'
import { Link } from 'react-router'
import cx from 'classnames'
import { debounce } from 'lodash'

import './RescheduleRecurrence.scss'
import ProfileMobileNavBar from 'components/ProfileMobileNavBar'
import RescheduleAliadaProfile from 'components/RescheduleAliadaProfile'
import AvailabilityCalendar from 'components/AvailabilityCalendar'
import AvailabilityLoader from 'components/AvailabilityLoader'
import RescheduleDurationField from 'components/RescheduleDurationField'
import { recurrencePeriodicity } from '@src/globals'
import * as paths from 'utils/paths'

class RescheduleRecurrence extends Component {
  constructor (props) {
    super(props)

    this.state = {
      selectedDate: undefined,
      duration: this.props.recurrence && this.props.recurrence.estimatedHours
    }

    const debounceWait = 500 // milliseconds
    this.onDurationChanged = debounce(this.onDurationChanged.bind(this), debounceWait)
    this.onDateSelected = this.onDateSelected.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  componentDidMount () {
    const {
      fetchRecurrence,
      params: {
        recurrenceId
      }
    } = this.props

    fetchRecurrence(recurrenceId)
  }

  componentWillReceiveProps (nextProps) {
    this.initializeDurationIfNeeded(nextProps)
  }

  initializeDurationIfNeeded ({ recurrence }) {
    if (!recurrence) {
      return
    }

    const needToInitializeDuration = !this.state.duration

    if (needToInitializeDuration) {
      const { estimatedHours } = recurrence

      this.setState({
        duration: parseFloat(estimatedHours)
      })
    }
  }

  componentDidUpdate (prevProps, prevState) {
    this.fetchAliadaIfNeeded(prevProps, prevState)
  }

  fetchAliadaIfNeeded (prevProps, prevState) {
    const { aliada } = this.props
    const { duration } = this.state
    const { duration: prevDuration } = prevState

    const availabilityIsMissing = aliada && !aliada.availability
    const durationChanged = duration !== prevDuration

    const needsToFetchAliada = availabilityIsMissing || durationChanged

    if (needsToFetchAliada) {
      this.fetchAliada()
    }
  }

  fetchAliada () {
    const {
      fetchAliada,
      recurrence,
      params: {
        recurrenceId
      }
    } = this.props
    const { duration } = this.state

    const availabilityDetails = {
      estimatedHours: duration,
      serviceTypeId: recurrencePeriodicity[recurrence.periodicity].serviceTypeId,
      coordinates: recurrence.address.location,
      recurrenceId
    }

    fetchAliada(recurrence.aliada, availabilityDetails)
  }

  onDateSelected (selectedDate) {
    this.setState({ selectedDate })
  }

  onDurationChanged (duration) {
    this.setState({ duration })
  }

  onSubmit (e) {
    const shouldPreventDefault = !this.state.selectedDate
    if (shouldPreventDefault) {
      e.preventDefault()
    }
  }

  isLoading () {
    const { recurrence, aliada } = this.props
    return !recurrence || !(aliada && aliada.availability)
  }

  render () {
    if (this.isLoading()) {
      const Loader = () => <div />
      return <Loader />
    }

    const {
      recurrence: {
        id: recurrenceId,
        estimatedHours
      },
      aliada,
      fetchingAliada,
      params: {
        userId
      }
    } = this.props

    const { selectedDate, duration } = this.state

    const confirmButtonClassName = cx(
      'Reschedule-reserveButton',
      'btn btn-primary btn-block btn-lg',
      {
        disabled: !selectedDate
      }
    )

    const confirmQueryobject = {
      aliadaId: aliada && aliada.id,
      estimatedHours: duration,
      datetime: selectedDate && selectedDate.format()
    }

    const confirmUrl = paths.rescheduleRecurrenceConfirm(userId, recurrenceId, confirmQueryobject)

    return (
      <div className='RescheduleRecurrence navbar-screen'>
        <ProfileMobileNavBar back>
          Modificar Recurrencia
        </ProfileMobileNavBar>

        <div className='RescheduleRecurrence-content navbar-screen-content'>
          <div className='navbar-screen-container'>
            <div className='RescheduleRecurrence-contentCard'>
              <div className='RescheduleRecurrence-cardTitle'>
                Cambio de fecha y hora de la recurrencia
              </div>

              <div className='RescheduleRecurrence-contentBody'>
                <div className='RescheduleRecurrence-header'>
                  <RescheduleAliadaProfile
                    aliada={aliada}
                    serviceDuration={parseFloat(duration || estimatedHours)}
                    />

                  <RescheduleDurationField
                    initialValue={parseFloat(estimatedHours)}
                    onChange={this.onDurationChanged}
                    />
                </div>

                <div className='RescheduleRecurrence-availability'>
                  <h3>
                    Elige qué día y hora te gustaría que {aliada.firstName} vaya a tu domicilio
                  </h3>

                {fetchingAliada
                  ? <AvailabilityLoader />
                  : <AvailabilityCalendar
                    availability={aliada.availability}
                    onChange={this.onDateSelected}
                    showUnavailableDays={false}
                  />
                }
                </div>

                <div className='RescheduleRecurrence-reserve'>
                  <Link
                    className={confirmButtonClassName}
                    to={confirmUrl}
                    onClick={this.onSubmit}
                    >
                    Guardar cambios
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

RescheduleRecurrence.displayName = 'RescheduleRecurrence'
RescheduleRecurrence.propTypes = {
  recurrence: PropTypes.object.isRequired,
  aliada: PropTypes.object.isRequired
}
RescheduleRecurrence.defaultProps = {}

export default RescheduleRecurrence



// WEBPACK FOOTER //
// ./src/screens/App/screens/Recurrences/screens/RescheduleRecurrence/RescheduleRecurrence.js